<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppFlicker, AppIconButton, AppSvgIcon } from '@libs/ui';

const { t } = i18n.global;

const browserStore = useBrowserStore();

interface ActivityDetailsHeaderProps {
  destination: string | undefined;
}
const props = defineProps<ActivityDetailsHeaderProps>();

interface ActivityDetailsHeaderEmits {
  (event: 'close'): void;
}
const emit = defineEmits<ActivityDetailsHeaderEmits>();
</script>

<template>
  <div
    v-if="browserStore.isSmallerThan900px"
    class="activity-details-header-mobile"
  >
    <AppSvgIcon
      class="close-icon"
      name="arrowLeft"
      size="24"
      @click="emit('close')"
    />
    <div v-if="props.destination" class="header-text">
      <span>{{ props.destination }}</span>
      <div class="dot" />
      <span>{{ t('planner.activity') }}</span>
    </div>
    <AppFlicker v-else width="spacing-96" height="spacing-12" />
    <div class="right" />
  </div>
  <div v-else class="activity-details-header-desktop">
    <div v-if="props.destination" class="header-text">
      <span>{{ props.destination }}</span>
      <div class="dot" />
      <span>{{ t('planner.activity') }}</span>
    </div>
    <AppFlicker v-else width="spacing-96" height="spacing-12" />
    <AppIconButton
      type="text"
      state="enabled"
      size="medium"
      :icon="{ name: 'close' }"
      :ariaLabel="$t('a11y.close_panel')"
      @click="emit('close')"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-details-header-mobile,
.activity-details-header-desktop {
  color: var(--color-soft-black);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-text {
    @include font-body-s-light;
    display: flex;
    flex-direction: row;
    gap: var(--spacing-8);
    align-items: center;
    .dot {
      width: 3px;
      height: 3px;
      border-radius: var(--border-radius-8);
      background-color: var(--color-neutral-dark);
    }
  }
}
.activity-details-header-mobile {
  padding: var(--spacing-12) 0;
  .close-icon {
    cursor: pointer;
  }
  .right {
    width: var(--spacing-24);
  }
}
</style>
